/* unplugin-vue-components disabled */import { render } from "./greenScreen.vue?vue&type=template&id=738b663d&scoped=true&ts=true"
import script from "./greenScreen.vue?vue&type=script&lang=ts"
export * from "./greenScreen.vue?vue&type=script&lang=ts"

import "./greenScreen.vue?vue&type=style&index=0&id=738b663d&lang=scss&scoped=true"

import exportComponent from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-738b663d"]])

export default __exports__